import { REGISTRATION_PAGE_ID } from "./escapeRoomConstants";

/** Acento por defecto (juego / registro web). */
export const DEFAULT_ER_ACCENT = "#7d00fc";

/**
 * Normaliza colores típicos de API y pickers a `#rrggbb`.
 * Acepta #RGB, #RRGGBB, RRGGBB sin #, rgb()/rgba(), número 0xRRGGBB.
 */
export function parseCssColor(raw) {
	if (raw == null) return null;
	if (typeof raw === "number" && Number.isFinite(raw)) {
		const n = Math.max(0, Math.min(0xffffff, Math.floor(raw)));
		return `#${n.toString(16).padStart(6, "0")}`;
	}
	if (typeof raw !== "string") return null;
	const s = raw.trim();
	if (!s) return null;
	const hex6 = /^#([0-9a-fA-F]{6})$/;
	const m6 = s.match(hex6);
	if (m6) return `#${m6[1].toLowerCase()}`;
	const hex3 = /^#([0-9a-fA-F]{3})$/;
	const m3 = s.match(hex3);
	if (m3) {
		const [r, g, b] = m3[1].split("");
		return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
	}
	if (/^[0-9a-fA-F]{6}$/.test(s)) return `#${s.toLowerCase()}`;
	if (/^[0-9a-fA-F]{3}$/.test(s)) {
		const [r, g, b] = s.split("");
		return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
	}
	const rgb = s.match(
		/^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*[\d.]+\s*)?\)$/i
	);
	if (rgb) {
		const clamp = (x) => Math.max(0, Math.min(255, parseInt(x, 10)));
		const toHex = (n) => clamp(n).toString(16).padStart(2, "0");
		return `#${toHex(rgb[1])}${toHex(rgb[2])}${toHex(rgb[3])}`;
	}
	return null;
}

function pagesFromGameShape(game) {
	if (!game) return [];
	const er = game.escapeRoom;
	if (er && typeof er === "object" && Array.isArray(er.pages)) return er.pages;
	return [];
}

/** Color `primaryColor` de la página registro del ER, si existe. */
export function getRegistrationPrimaryRawFromGame(game, group) {
	const gameFromGroup = group?.game && typeof group.game === "object" ? group.game : null;
	for (const g of [game, gameFromGroup]) {
		const pages = pagesFromGameShape(g);
		const regPage = pages.find((p) => String(p?.pageId || p?._id || "") === REGISTRATION_PAGE_ID);
		const raw = regPage?.registrationDesign?.primaryColor;
		if (raw != null && raw !== "") return raw;
	}
	return undefined;
}

/** Pantalla /register: registro ER → color de juego. */
export function resolveRegisterScreenPrimary(game) {
	if (!game) return DEFAULT_ER_ACCENT;
	const fromReg = parseCssColor(getRegistrationPrimaryRawFromGame(game, null));
	if (fromReg) return fromReg;
	const fromGame = parseCssColor(game.primaryColor);
	if (fromGame) return fromGame;
	return DEFAULT_ER_ACCENT;
}

/** TopBar: mismo orden que pediste (acento registro web primero, luego juego). */
export function resolveTopBarPrimary(game, group) {
	const gameFromGroup = group?.game && typeof group.game === "object" ? group.game : null;
	const registerPrimary = getRegistrationPrimaryRawFromGame(game, group);
	const candidates = [
		registerPrimary,
		game?.primaryColor,
		gameFromGroup?.primaryColor,
		game?.escapeRoom?.primaryColor,
		gameFromGroup?.escapeRoom?.primaryColor,
	];
	for (const c of candidates) {
		const parsed = parseCssColor(c);
		if (parsed) return parsed;
	}
	return DEFAULT_ER_ACCENT;
}
